export default __webpack_public_path__ + "static/media/md-mobile.e9bef37c.png";